const dataAccessMethods = require('../../dataAccessMethods');
const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
const innerBlockly = require('blockly');
class BlocklyView extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock) {
        code.namespace = blocklyBlock.getFieldValue('namespace');
        code.relation = blocklyBlock.getFieldValue('relation');
        return JSON.stringify(code);
    }
    addToBlocksCustom(color, blocklyBlock, hNodeType) {
        blocklyBlock
            .appendDummyInput()
            .setAlign(innerBlockly.ALIGN_RIGHT)
            .appendField('  Namespace:')
            .appendField(new innerBlockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace');
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        blocklyBlock
            .appendDummyInput()
            .setAlign(innerBlockly.ALIGN_RIGHT)
            .appendField('  Relation:')
            .appendField(
                new innerBlockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                'relation'
            );
        if (hNodeType === 'MenuEditor') {
            blocklyBlock.appendStatementInput('children').appendField('Children:', 'childrenField');
        }
    }
}

module.exports = BlocklyView;
